import autocomplete from '@jupiterone/query-language-autocomplete';
import { AutocompleteContext } from '@jupiterone/query-language-autocomplete';
import { AutocompleteInput } from '@jupiterone/query-language-autocomplete/dist/src/types';
import { AceSuggestion } from './types';

const fetchAceSuggestions = async (
  prefix: string,
  input: AutocompleteInput,
  context: AutocompleteContext
): Promise<AceSuggestion[]> => {
  const result = await autocomplete(context, input);
  const { start, end } = result.replacementRange;

  return result.suggestions.map((suggestion) => {
    const tokenInProgress =
      prefix !== ' '
        ? prefix
            .replace(/[\(\)]/, '')
            .split(/[|\s\.]/)
            .slice(-1)[0]
        : prefix;

    // Discussion: The ace editor is pretty unusual about these completions.
    // It has to replace the entire prefix and yet we need to know what the
    // current token is in progress since there may be times when we are asked
    // for suggestions in the middle of a token (e.g. backspace after next
    // token).
    let value = suggestion.value;
    if (prefix === input.text.slice(0, input.cursorPosition)) {
      value = `${prefix.slice(0, start)}${suggestion.value}${prefix.slice(
        end
      )}`;
    } else if (
      !tokenInProgress ||
      !suggestion.value.toLowerCase().includes(tokenInProgress.toLowerCase())
    ) {
      value = `${prefix}${suggestion.value}`;
    }

    return {
      caption: suggestion.value,
      value,
      meta: suggestion.meta,
      score: suggestion.score || 1,
    };
  });
};

export default fetchAceSuggestions;
